import { Element as NodeElement } from "@easy-email-pro-core/typings";
import { cloneDeep, set } from "lodash";

import { NodeUtils } from "@easy-email-pro-core/utils/NodeUtils";

export function getUniversalElements(data: { content: NodeElement }) {
  const map: Record<
    string,
    Array<{ idx: string; blockData: NodeElement }>
  > = {};

  const loop = (blockData: NodeElement, idx: string) => {
    if (blockData.uid) {
      if (!map[blockData.uid]) {
        map[blockData.uid] = [] as Array<{
          idx: string;
          blockData: NodeElement;
        }>;
      }
      map[blockData.uid].push({
        idx,
        blockData,
      });
    }

    blockData.children.forEach((item, index) => {
      if (NodeUtils.isTextNode(item)) return;

      loop(item, NodeUtils.getChildIdx(idx, index));
    });
  };

  loop(data.content, NodeUtils.getPageIdx());

  return map;
}

export function transformUniversalElements<
  T extends {
    content: NodeElement;
    universalElements: Record<string, NodeElement>;
  }
>(data: T): T["content"] {
  const cloneContent = cloneDeep(data);
  const loop = (element: NodeElement, idx: string) => {
    if (element.uid) {
      if (!data.universalElements) {
        throw new Error(`No universalElements`);
      }
      if (!data.universalElements[element.uid]) {
        throw new Error(`Can not find element by uid ${element.uid}`);
      }
      set(cloneContent, idx, cloneDeep(data.universalElements[element.uid]));
    }
    element.children.forEach((item, index) => {
      if (NodeUtils.isTextNode(item)) return;

      loop(item, NodeUtils.getChildIdx(idx, index));
    });
  };

  loop(cloneContent.content, NodeUtils.getPageIdx());

  return cloneContent.content;
}
